export default __webpack_public_path__ + "static/media/000_intro_part2.first.be1709c1.png";